import { render } from "./UltraLink.vue?vue&type=template&id=0c9fde38"
import script from "./UltraLink.vue?vue&type=script&lang=js"
export * from "./UltraLink.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__